import {createSelector} from '@reduxjs/toolkit';
import isEqual from 'lodash.isequal';
import {createPredicates} from 'src/modules/attributes/filter-utils/createPredicates';
import {getAttributesFilters} from 'src/modules/attributes/services/filters';
import {defaultState} from 'src/modules/attributes/services/filters/reducer';
import {getAllAttributesCount} from 'src/modules/tabs-panel/services';
import {AttributeRelationInfo} from 'src/openapi/models/AttributeRelationInfo';
import {RootState} from 'src/store/store';
import {filterDataByPredicates} from 'src/utils/filterDataByPredicates';

export const getAttributesInfo = (state: RootState): Array<AttributeRelationInfo> => state.attributesInfo.data;

export const getFilteredAttributes = createSelector(
    [getAttributesFilters, getAttributesInfo],
    (filters, rows = []) => filterDataByPredicates(rows, filters, createPredicates),
);

export const getFilteredAttributesLength = createSelector(
    [getFilteredAttributes, getAllAttributesCount, getAttributesFilters],
    (filteredAttributes, allAttributesCount, filters) => {
        const isDefaultFilters = isEqual(filters, defaultState.data);

        return isDefaultFilters ? allAttributesCount : filteredAttributes.length;
    },
);
